import React from 'react';
export const FireIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-117">
    <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z" data-id="element-118"></path>
  </svg>;
export const LightningIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-119">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-120"></path>
  </svg>;
export const LockIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-121">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-122"></rect>
    <path d="M7 11V7a5 5 0 0110 0v4" data-id="element-123"></path>
  </svg>;
export const DownloadIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-124">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" data-id="element-125"></path>
    <polyline points="7 10 12 15 17 10" data-id="element-126"></polyline>
    <line x1="12" y1="15" x2="12" y2="3" data-id="element-127"></line>
  </svg>;
export const CheckIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-128">
    <polyline points="20 6 9 17 4 12" data-id="element-129"></polyline>
  </svg>;
export const MoneyEvaporateIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-130">
    <path d="M12 2v20" data-id="element-131"></path>
    <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" data-id="element-132"></path>
    <path d="M4 4l2-2" data-id="element-133"></path>
    <path d="M20 4l-2-2" data-id="element-134"></path>
    <path d="M4 20l2 2" data-id="element-135"></path>
    <path d="M20 20l-2 2" data-id="element-136"></path>
  </svg>;
export const AnxietyIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-137">
    <circle cx="12" cy="12" r="10" data-id="element-138"></circle>
    <path d="M8 15h8" data-id="element-139"></path>
    <path d="M9 9h.01" data-id="element-140"></path>
    <path d="M15 9h.01" data-id="element-141"></path>
    <path d="M12 12v.01" data-id="element-142"></path>
  </svg>;
export const IceIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-143">
    <path d="M12 2L2 7l10 5 10-5-10-5z" data-id="element-144"></path>
    <path d="M2 17l10 5 10-5" data-id="element-145"></path>
    <path d="M2 12l10 5 10-5" data-id="element-146"></path>
  </svg>;
export const SadIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-147">
    <circle cx="12" cy="12" r="10" data-id="element-148"></circle>
    <path d="M16 16s-1.5-2-4-2-4 2-4 2" data-id="element-149"></path>
    <line x1="9" y1="9" x2="9.01" y2="9" data-id="element-150"></line>
    <line x1="15" y1="9" x2="15.01" y2="9" data-id="element-151"></line>
  </svg>;
export const CycleIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-152">
    <path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8" data-id="element-153"></path>
    <path d="M3 3v5h5" data-id="element-154"></path>
  </svg>;
export const BrainIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-155">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" data-id="element-156"></path>
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" data-id="element-157"></path>
  </svg>;
export const HeartIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-158">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" data-id="element-159"></path>
  </svg>;
export const PenIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-160">
    <path d="M12 19l7-7 3 3-7 7-3-3z" data-id="element-161"></path>
    <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" data-id="element-162"></path>
    <path d="M2 2l7.586 7.586" data-id="element-163"></path>
    <circle cx="11" cy="11" r="2" data-id="element-164"></circle>
  </svg>;
export const XIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-165">
    <line x1="18" y1="6" x2="6" y2="18" data-id="element-166"></line>
    <line x1="6" y1="6" x2="18" y2="18" data-id="element-167"></line>
  </svg>;
export const ShieldIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-168">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-169"></path>
  </svg>;
export const PlusIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-170">
    <line x1="12" y1="5" x2="12" y2="19" data-id="element-171"></line>
    <line x1="5" y1="12" x2="19" y2="12" data-id="element-172"></line>
  </svg>;
export const MinusIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-173">
    <line x1="5" y1="12" x2="19" y2="12" data-id="element-174"></line>
  </svg>;
export const EnvelopeIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-175">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" data-id="element-176"></path>
    <polyline points="22,6 12,13 2,6" data-id="element-177"></polyline>
  </svg>;
export const ClockIcon = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-178">
    <circle cx="12" cy="12" r="10" data-id="element-179"></circle>
    <polyline points="12 6 12 12 16 14" data-id="element-180"></polyline>
  </svg>;